/**
 * Цвет плитки значка — по образцу настроек Telegram: у каждого раздела свой.
 * Отдельным модулем: им пользуются и корень S-01 (стартовый чанк), и разделы с
 * поиском (свои чанки) — компоненты строк выбора в стартовый чанк не попадают.
 */
export type SettingsTone =
  | 'blue'
  | 'indigo'
  | 'purple'
  | 'pink'
  | 'red'
  | 'orange'
  | 'amber'
  | 'green'
  | 'teal'
  | 'sky'
  | 'gray'

/** Тон → класс плитки в settings.module.css. */
export const TONE_CLASS: Record<SettingsTone, string> = {
  blue: 'tileBlue',
  indigo: 'tileIndigo',
  purple: 'tilePurple',
  pink: 'tilePink',
  red: 'tileRed',
  orange: 'tileOrange',
  amber: 'tileAmber',
  green: 'tileGreen',
  teal: 'tileTeal',
  sky: 'tileSky',
  gray: 'tileGray',
}
